import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { FiTrash2, FiPlus, FiMinus, FiShoppingBag, FiArrowRight } from 'react-icons/fi';
import './Cart.css';

const NPR = (n) => 'NPR ' + parseFloat(n || 0).toLocaleString('en-NP');

const Cart = () => {
  const { items, updateQty, removeItem, total, cart } = useCart();
  const navigate = useNavigate();

  if (items.length === 0) return (
    <div className="cart-page container">
      <div className="cart-empty">
        <div className="empty-icon">🛒</div>
        <h2>Your Cart is Empty</h2>
        <p className="text-muted">Browse our products and add items to your cart.</p>
        <Link to="/products" className="btn btn-primary">Shop Now</Link>
      </div>
    </div>
  );

  const subtotal = total;
  const shipping = subtotal > 50000 ? 0 : 500;
  const grandTotal = subtotal + shipping;

  return (
    <div className="cart-page">
      <div className="container">
        <h1 className="page-title" style={{ marginBottom: 32 }}>Shopping Cart</h1>
        <div className="cart-layout">
          {/* Items */}
          <div className="cart-items">
            {items.map((item) => {
              const img = item.product?.images?.find((i) => i.is_primary) || item.product?.images?.[0];
              return (
                <div key={item.id} className="cart-item">
                  <div className="ci-img">
                    {img ? <img src={img.image} alt={item.product?.title} /> : <FiShoppingBag />}
                  </div>
                  <div className="ci-info">
                    <Link to={`/products/${item.product?.slug}`} className="ci-title">
                      {item.product?.title}
                    </Link>
                    {item.product?.category && <span className="ci-cat text-muted">{item.product.category}</span>}
                    <div className="ci-price">{NPR(item.unit_price)}</div>
                  </div>
                  <div className="ci-qty">
                    <button onClick={() => updateQty(item.id, item.quantity - 1)}><FiMinus /></button>
                    <span>{item.quantity}</span>
                    <button onClick={() => updateQty(item.id, item.quantity + 1)}><FiPlus /></button>
                  </div>
                  <div className="ci-total">{NPR(parseFloat(item.unit_price) * item.quantity)}</div>
                  <button className="ci-remove" onClick={() => removeItem(item.id)}><FiTrash2 /></button>
                </div>
              );
            })}
          </div>

          {/* Summary */}
          <div className="cart-summary card">
            <h3 className="summary-title">Order Summary</h3>
            <div className="summary-row">
              <span>Subtotal ({items.reduce((s, i) => s + i.quantity, 0)} items)</span>
              <span>{NPR(subtotal)}</span>
            </div>
            <div className="summary-row">
              <span>Shipping (Kathmandu)</span>
              <span>{shipping === 0 ? <span style={{ color: '#00c850' }}>Free</span> : NPR(shipping)}</span>
            </div>
            {shipping === 0 && (
              <div className="free-shipping-msg">🎉 Free shipping on orders above NPR 50,000!</div>
            )}
            <hr className="divider" />
            <div className="summary-row total-row">
              <span>Total</span>
              <span>{NPR(grandTotal)}</span>
            </div>
            <button
              className="btn btn-primary btn-lg checkout-btn"
              onClick={() => navigate('/checkout', { state: { cartId: cart?.id, total: grandTotal } })}
            >
              Proceed to Checkout <FiArrowRight />
            </button>
            <Link to="/products" className="btn btn-ghost continue-btn">Continue Shopping</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cart;